/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AccTypesEnum = "Bank_Acc" | "VPA" | "%future added value";
export type KycUpdateMutationVariables = {|
  accNum?: ?string,
  accType: AccTypesEnum,
  bankName?: ?string,
  beneficiaryName: string,
  email?: ?string,
  ifscCode?: ?string,
  upiId?: ?string,
|};
export type KycUpdateMutationResponse = {|
  +kycUpdate: ?{|
    +kyc: ?{|
      +id: string
    |},
    +message: ?string,
  |}
|};
export type KycUpdateMutation = {|
  variables: KycUpdateMutationVariables,
  response: KycUpdateMutationResponse,
|};
*/


/*
mutation KycUpdateMutation(
  $accNum: String
  $accType: AccTypesEnum!
  $bankName: String
  $beneficiaryName: String!
  $email: String
  $ifscCode: String
  $upiId: String
) {
  kycUpdate(accNum: $accNum, accType: $accType, bankName: $bankName, beneficiaryName: $beneficiaryName, email: $email, ifscCode: $ifscCode, upiId: $upiId) {
    kyc {
      id
    }
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accNum"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bankName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "beneficiaryName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ifscCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "upiId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accNum",
        "variableName": "accNum"
      },
      {
        "kind": "Variable",
        "name": "accType",
        "variableName": "accType"
      },
      {
        "kind": "Variable",
        "name": "bankName",
        "variableName": "bankName"
      },
      {
        "kind": "Variable",
        "name": "beneficiaryName",
        "variableName": "beneficiaryName"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "ifscCode",
        "variableName": "ifscCode"
      },
      {
        "kind": "Variable",
        "name": "upiId",
        "variableName": "upiId"
      }
    ],
    "concreteType": "KYCUpdate",
    "kind": "LinkedField",
    "name": "kycUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "KYCNode",
        "kind": "LinkedField",
        "name": "kyc",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KycUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KycUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b5143827a16a65160acba7e704e890e",
    "id": null,
    "metadata": {},
    "name": "KycUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation KycUpdateMutation(\n  $accNum: String\n  $accType: AccTypesEnum!\n  $bankName: String\n  $beneficiaryName: String!\n  $email: String\n  $ifscCode: String\n  $upiId: String\n) {\n  kycUpdate(accNum: $accNum, accType: $accType, bankName: $bankName, beneficiaryName: $beneficiaryName, email: $email, ifscCode: $ifscCode, upiId: $upiId) {\n    kyc {\n      id\n    }\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7babc11e4a1d6165b3c37a31ee6c50f4';

module.exports = node;
